export const MarketingEventsFactDepartmentsGridPluginSettings: IPluginSettings = {
    name: 'Факты по участникам маркетинговых мероприятий',
    mnemocode: 'marketing_events_factDepartments_plugin',
    permission: 'MarketingEvents',
    columns: (() => {
        let index = 0;
        return [
            {
                order: index++,
                propertyName: 'idGoods',
                propertyType: 'number',
                displayName: 'ID товара',
                visibility: false,
                width: 100
            },
            {
                order: index++,
                propertyName: 'idDepartment',
                propertyType: 'number',
                displayName: 'ID подразделения',
                visibility: false,
                width: 150
            },
            {
                order: index++,
                propertyName: 'guidEs',
                propertyType: 'string',
                displayName: 'GUID товара ЕС', //Уникальный идентификатор товара в ЕС
                visibility: false,
                width: 300
            },
            {
                order: index++,
                propertyName: 'quantityPlanMember',
                propertyType: 'number',
                displayName: 'План участнику (упаковок)', //): План участнику (количество упаковок товара)
                visibility: true,
                width: 180
            },
            {
                order: index++,
                propertyName: 'quantityFactMember',
                propertyType: 'number',
                displayName: 'Факт участнику (упаковок)', //Факт по участнику (количество упаковок товара)
                visibility: true,
                width: 180
            },
            {
                order: index++,
                propertyName: 'priceRef',
                propertyType: 'number',
                displayName: 'Референтная цена',
                visibility: true,
                width: 150
            },
            {
                order: index++,
                propertyName: 'bonusPlanMember',
                propertyType: 'number',
                displayName: 'Бонус план участнику',
                visibility: true,
                width: 180
            },
            {
                order: index++,
                propertyName: 'bonusFactMember',
                propertyType: 'number',
                displayName: 'Бонус факт участнику',
                visibility: true,
                width: 180
            },
            {
                order: index++,
                propertyName: 'bonusPlanProvisor',
                propertyType: 'number',
                displayName: 'Бонус план провизору',
                visibility: true,
                width: 180
            },
            {
                order: index++,
                propertyName: 'bonusFactProvisor',
                propertyType: 'number',
                displayName: 'Бонус факт провизору',
                visibility: true,
                width: 180
            },
            {
                order: index++,
                propertyName: 'predictBonus',
                propertyType: 'number',
                displayName: 'Прогноз бонуса',
                visibility: true,
                width: 150
            },
            {
                order: index++,
                propertyName: 'predictQuantity',
                propertyType: 'number',
                displayName: 'Прогноз количества',
                visibility: true,
                width: 160
            },
            {
                order: index++,
                propertyName: 'quantityPlanProvisor',
                propertyType: 'number',
                displayName: 'План провизору (упаковок)',
                visibility: true,
                width: 180
            },
            {
                order: index++,
                propertyName: 'quantityFactProvisor',
                propertyType: 'number',
                displayName: 'Факт провизору (упаковок)',
                visibility: true,
                width: 180
            },
            {
                order: index++,
                propertyName: 'amountPlanMember',
                propertyType: 'number',
                displayName: 'План полный по подразделению',
                visibility: true,
                width: 200
            },
            {
                order: index++,
                propertyName: 'amountFactMember',
                propertyType: 'number',
                displayName: 'Факт полный по подразделению',
                visibility: true,
                width: 200
            },
            {
                order: index++,
                propertyName: 'prcExec',
                propertyType: 'number',
                displayName: 'Процент выполнения',
                visibility: true,
                width: 150
            },
            {
                order: index++,
                propertyName: 'quantityStockFact',
                propertyType: 'number',
                displayName: 'Факт остатков в упаковках',
                visibility: true,
                width: 180
            },
            {
                order: index++,
                propertyName: 'idMarketingEventGlobal',
                propertyType: 'string',
                displayName: 'ID маркетингового мероприятия',
                visibility: false,
                width: 300
            },
            {
                order: index++,
                propertyName: 'deleted',
                propertyType: 'boolean',
                displayName: 'Удален',
                visibility: false,
                width: 100
            },
            {
                order: index++,
                propertyName: 'dateCreated',
                propertyType: 'datetime',
                displayName: 'Дата создания',
                visibility: false,
                width: 150
            },
            {
                order: index++,
                propertyName: 'dateModified',
                propertyType: 'datetime',
                displayName: 'Дата изменения',
                visibility: false,
                width: 150
            },
            {
                order: index++,
                propertyName: 'dateDeleted',
                propertyType: 'datetime',
                displayName: 'Дата удаления',
                visibility: false,
                width: 150
            },
            {
                order: index++,
                propertyName: 'idGlobal',
                propertyType: 'string',
                displayName: 'ID',
                visibility: false,
                width: 300
            }
        ];
    })()
};